{
    "DAYS": "dagen",
    "HOURS": "uren",
    "MINUTES": "min",
    "SECONDS": "sec",
    "STARTING_SOON": "Begint binnenkort...",
    "EVENT_NOT_STARTED": "Dit evenement is nog niet begonnen...",
    "DEFAULT_ERROR": "Afspelfout",
    "DEFAULT_ERROR_DESCRIPTION": "Kan de video niet afspelen. Probeer het later opnieuw.",
    "API_ERROR": "Kan videogegevens niet ophalen",
    "API_ERROR_DESCRIPTION": "Fout bij het ophalen van videogegevens. Controleer uw video-ID en internetverbinding en probeer het opnieuw.",
    "ERROR_CODE_NOT_AUTHENTICATED": "Autorisatie",
    "ERROR_CODE_NOT_AUTHENTICATED_DESCRIPTION": "U heeft geen toestemming om deze video af te spelen.",
    "ERROR_CODE_GEO_BLOCKED": "Geoblocking Beperking",
    "ERROR_CODE_GEO_BLOCKED_DESCRIPTION": "Sorry, deze video is niet beschikbaar in uw regio vanwege geoblocking beperkingen.",
    "ERROR_CODE_NOT_ENTITLED": "Geen recht",
    "ERROR_CODE_NOT_ENTITLED_DESCRIPTION": "Sorry, u heeft geen recht om deze video af te spelen.",
    "ERROR_CODE_VPN_BLOCKED": "VPN GEBLOKKEERD",
    "ERROR_CODE_VPN_BLOCKED_DESCRIPTION": "Deze video is niet beschikbaar vanwege het gebruik van een VPN.",
    "ERROR_CODE_IP_CHANGED": "Netwerk gewijzigd",
    "ERROR_CODE_IP_CHANGED_DESCRIPTION": "U bent onverwacht overgeschakeld naar een ander netwerk. Probeer het opnieuw.",
    "ERROR_CODE_VPN_DETECTED": "VPN gedetecteerd",
    "ERROR_CODE_VPN_DETECTED_DESCRIPTION": "We hebben een VPN gedetecteerd. Schakel deze uit en probeer het opnieuw.",
    "ERROR_CODE_ANONYMOUS_PROXY": "Anonieme proxy gedetecteerd",
    "ERROR_CODE_ANONYMOUS_PROXY_DESCRIPTION": "We hebben een anonieme proxy of server gedetecteerd. Schakel deze uit en probeer het opnieuw."
}
